import { render } from "./VehiclePixBuying.vue?vue&type=template&id=278883b5"
import script from "./VehiclePixBuying.vue?vue&type=script&lang=js"
export * from "./VehiclePixBuying.vue?vue&type=script&lang=js"

import "./VehiclePixBuying.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__